import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import './FormComplainLocation.css'
import Axios from 'axios'
import ReactTooltip from 'react-tooltip'

const descriptionCustomer = "Se considera cliente si cuenta con un contrato firmado con marhnos"

class FormComplainLocation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            locations:[],
            show: false
        }

        this.isCustomer = this.isCustomer.bind(this)
        this.loadTowers = this.loadTowers.bind(this)
        this.loadLevels = this.loadLevels.bind(this)
        this.loadLocations = this.loadLocations.bind(this)
        this.putOption = this.putOption.bind(this)
    }

    componentDidMount(){
        setTimeout(this.isCustomer, 10000);
    }

    isCustomer = () => {
        console.log(this.props.projects.length)
        if(this.props.projects.length > 0){
            let contentLocations = document.getElementById("customer").checked ?
            (
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <select id="project" className="form-control" onChange={this.loadTowers} required>
                            {this.props.projects.map(this.putOption)}
                            <option value="" disabled selected hidden>Desarrollo*</option>
                        </select>
                    </div>
                    <div id="divtower" className="col-sm-4 col-md-2 col-lg-2"></div>
                    <div id="divlevel" className="col-sm-4 col-md-2 col-lg-2"></div>
                    <div id="divlocation" className="col-sm-4 col-md-2 col-lg-2"></div>
                </div>
            ) :
            (
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <select id="project" className="form-control" required>
                            {this.props.projects.map(this.putOption)}
                            <option value="" disabled selected hidden>Desarrollo*</option>
                        </select>
                    </div>
                </div>
            )
        ReactDOM.render(contentLocations, document.getElementById('divLocations'))
        }else{
            setTimeout(this.isCustomer, 2000)
        }
    }

    loadTowers = () => {
        let project = document.getElementById('project').value
        this.setState({complain:{project:project}})
        Axios.get('/api/locations/'+project).then((res) => {
            this.setState({locations:res.data})
            const selectTower = 
            <select id="tower" className="form-control" onChange={this.loadLevels} required>
                <option value="" selected disabled hidden>Torre*</option>
                {Array.from(new Set(this.state.locations.map(s =>s[0]))).map(this.putOption)}                    
            </select>
            ReactDOM.render(selectTower, document.getElementById('divtower'))
            const elements=["tower", "level", "location"]
            for(var i=0; i<elements.length; i++){
                try{
                    document.getElementById(elements[i]).options[0].selected = true;	
                    document.getElementById(elements[i]).options[0].disabled = true;
                    document.getElementById(elements[i]).options[0].hidden = true;
                }catch(e){}                    
            }	
        })
    }

    loadLevels = () => {
        let tower = document.getElementById('tower').value
        var levels = this.state.locations.filter(function get(l){
            return l[0]===tower
        })
        levels = Array.from(new Set(levels.map(s =>s[1])))
        const selectLevel = 
        <select id="level" className="form-control" onChange={this.loadLocations} required>
            <option value="" disabled selected hidden>Nivel*</option>
            {levels.sort().map(this.putOption)}
        </select>
        ReactDOM.render(selectLevel, document.getElementById('divlevel'))
        const elements=["level", "location"]
        for(var i=0; i<elements.length; i++){
            try{
                document.getElementById(elements[i]).options[0].selected = true;	
                document.getElementById(elements[i]).options[0].disabled = true;
                document.getElementById(elements[i]).options[0].hidden = true;
            }catch(e){}                    
        }	
    } 
    
    loadLocations = () => {
        let tower = document.getElementById('tower').value
        let level = document.getElementById('level').value
        var locations = this.state.locations.filter(function get(l){
            return l[0]===tower && l[1]===level
        })
        locations = Array.from(new Set(locations.map(s =>s[2])))
        const selectLocation = 
        <select id="location" className="form-control" required>
            <option value="" disabled selected hidden>Depto*</option>
            {locations.sort().map(this.putOption)}
        </select>
        ReactDOM.render(selectLocation, document.getElementById('divlocation'))
        const elements=["location"]
            for(var i=0; i<elements.length; i++){
                try{
                    document.getElementById(elements[i]).options[0].selected = true;	
                    document.getElementById(elements[i]).options[0].disabled = true;
                    document.getElementById(elements[i]).options[0].hidden = true;
                }catch(e){}                    
            }	
    }

    putOption = (option) => {
        return <option key={option} value={option}>{option}</option>
    }


    render(){
        const { show } = this.state;
        return(
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <label className="labelCustomer">Indícanos ai nos escribes por (Queja/Sugerencia/Agradecimiento):*&nbsp;&nbsp;</label>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <select id="type" className="form-control" required>
                            <option value="" selected>Tipo*</option>
                            <option value="Queja">Queja</option>
                            <option value="Sugerencia">Sugerencia</option>
                            <option value="Agradecimiento">Agradecimiento</option>
                        </select>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 labelForm">
                        <label className="labelCustomer">¿Eres cliente de marhnos?*&nbsp;&nbsp;</label>
                        <label className="switch">
                            <input id="customer" type="checkbox" onChange={this.isCustomer} className="btnSwitch"/>
                            <span className="slider round"></span>
                        </label> &nbsp;&nbsp;&nbsp;&nbsp;
                        <ReactTooltip id={`tooltip-right`} type="error">
                            <span>{descriptionCustomer}</span>
                        </ReactTooltip>
                    </div>
                </div>
                <div id="divLocations"></div>
            </div>
        )
    }
}

export default FormComplainLocation


// WEBPACK FOOTER //
// ./src/components/FormComplainLocation/FormComplainLocation.js